import styled from '@emotion/styled';
import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import _Error from '@material-ui/icons/Error';
import { ChangeEvent, createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionSingleLineText } from '../../../../../generated/graphql';
import { SPACING_UNIT } from '../../../../constant/spacing';
import mq from '../../../../styleUtility/mediaquery';
import { SingleLineTextValue } from '../../../../types/DynamicSchema';
import LfToBr from '../../../primitive/LfToBr';
import Base from './Base';

type Props = {
  field: DynamicSchemaDefinitionSingleLineText;
  value: SingleLineTextValue;
  errors: Array<Error>;
  onChange: (e: ChangeEvent<HTMLElement>, value: SingleLineTextValue) => void;
  className?: string;
};

const SingleLineTextField: FC<Props> = ({ field, value, errors, onChange, className }) => {
  const validationErrorTexts = errors.map((err) => (
    <FormHelperText error key={err.message}>
      <StyledErrorIcon />

      <FormattedMessage id={`creative_brief_editor.field.validation_error.${err.message}`} />
    </FormHelperText>
  ));

  return (
    <Base field={field} labelPaddingTop={5} className={className}>
      <FormControl fullWidth required={field.isRequired}>
        <StyledInput
          id={`single-line-text-field-${field.key}`}
          placeholder={field.placeholder}
          defaultValue={value}
          error={errors.length >= 1}
          onChange={(e) => onChange(e, e.currentTarget.value)}
        />

        {validationErrorTexts}

        {field.helperText ? (
          <FormHelperText>
            <LfToBr text={field.helperText} />
          </FormHelperText>
        ) : null}
      </FormControl>
    </Base>
  );
};

const StyledInput = styled(TextField)`
  > input {
    line-height: 1.4;
    ::placeholder {
      opacity: 0.3;
    }
  }

  ${mq('sp')} {
    input {
      ::placeholder {
        font-size: 10px;
      }
    }
  }
`;

const StyledErrorIcon = styled(_Error)`
  margin-right: ${SPACING_UNIT / 2}px;
  vertical-align: bottom;
  width: 14px;
  height: 14px;
`;

export default SingleLineTextField;
